import Vue from 'vue';
import moment from 'moment';

export default Vue.mixin({
    methods: {
        utcOffsetByDate(date) {
            let offset = moment(date).format('Z');

            if (offset.indexOf(':') === false) {
                return offset;
            }

            let sign = offset.substr(0, 1);
            offset = offset.substr(1, 5).split(':');

            return `${sign}${parseInt(offset[0])}` + (parseInt(offset[1]) > 0 ? `:${offset[1]}` : '');
        }
    },
})
